import { IncomingMessage } from "http";
import { NextApiRequestCookies } from "next/dist/server/api-utils";

type IncomingMessageWithCookies = IncomingMessage & {
  cookies?: NextApiRequestCookies;
};

export default (req: IncomingMessageWithCookies) => req.cookies || {};
